import script from "./SideBarMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarMenu.vue?vue&type=script&setup=true&lang=js"

import "./SideBarMenu.vue?vue&type=style&index=0&id=3dfa8965&lang=css"

const __exports__ = script;

export default __exports__